/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Does_4Inputs */

const en_bot_does_4 = /** @type {(inputs: Bot_Does_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honours Content-Signal: when a site says ai-input=no, its content is not sent to an AI model and the analysis stops.`)
};

const id_bot_does_4 = /** @type {(inputs: Bot_Does_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mematuhi Content-Signal: bila situs menyatakan ai-input=no, isinya tidak dikirim ke model AI dan analisis dihentikan.`)
};

/**
* | output |
* | --- |
* | "Honours Content-Signal: when a site says ai-input=no, its content is not sent to an AI model and the analysis stops." |
*
* @param {Bot_Does_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_does_4 = /** @type {((inputs?: Bot_Does_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Does_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_does_4(inputs)
	return en_bot_does_4(inputs)
});